import types from './types';

function apSecureReducer(state, action) {
  switch(action.type) {
    case types.SET_OPTION_SELECTED:
      return {...state, option: action.option}
    case types.SET_BENEFICIARIES:
      return {...state, beneficiaries: action.beneficiaries}
    case types.SET_CREDIT:
      return {...state, credit: action.credit}
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation}
    case types.SET_TAKER_IDENTIFICATION_TYPE:
      return {...state, taker: {...state.taker, tipo_documento: action.tipo_documento, documento: action.documento}}
    case types.SET_TAKER_SELECTED_CITY:
      return {...state, taker: {...state.taker, city: action.city}}
    case types.SET_TAKER_SELECTED_STATE:
      return {...state, taker: {...state.taker, state: action.state}}
    case types.SET_TAKER_DATA:
      return {...state, taker: action.taker}
    case types.SET_BENEFICIARIE_USER_INFO:
      return {...state, beneficiariesUserInfo: action.beneficiariesUserInfo}
    case types.SET_TAKER_GENDER:
      return {...state, taker: {...state.taker, genero: action.genero}}
    case types.SET_TAKER_MARITAL_STATUS:
      return {...state, taker: {...state.taker, estadoCivil: action.estadoCivil}}
    case types.SET_PLAN:
      return {...state, plan: action.plan}
    default:
      return state;
  }
}

export default apSecureReducer;
